import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PlanningApiService, PlanningDataService, PlanningFormService } from '../../../shared/services';

@Component({
  selector: 'tax-rate',
  templateUrl: './tax-rate.component.html',
  styleUrls: ['./tax-rate.component.css']
})
export class TaxRateComponent implements OnInit, OnChanges, OnDestroy {

  @Input() projection;

  currentProjection;
  testedParty;
  otherEntity;
  taxRateForm: FormGroup;
  formSubscription: Subscription;
  defaultRates;

  testedPartyShowTax = false;
  otherEntityShowTax = false;
  taxRatesConfirmed = false;
  formChanges;

  msgViewed = false;

  constructor(
    private _planningApiService: PlanningApiService,
    private _planningDataService: PlanningDataService,
    private _planningFormService: PlanningFormService
  ) { }

  ngOnInit() {
    this.currentProjection = this.projection;
    this.getMetaData();
    this.checkIfAlreadyValid();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.currentProjection = changes.projection.currentValue;
    this.findTestedParty();
    this.taxRateForm = new FormGroup({
      otherEntityRate: new FormControl(
        this.otherEntity && this.otherEntity.jurisdiction.taxRate && (this.otherEntity.jurisdiction.taxRate * 100).toPrecision(4) || 0
      ),
      testedPartyRate: new FormControl(
        this.testedParty && this.testedParty.jurisdiction.taxRate && (this.testedParty.jurisdiction.taxRate * 100).toPrecision(4) || 0
      ),
    });

    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }

    this.formSubscription = this.taxRateForm.valueChanges.subscribe((data) => {
      for (let rate in data) {
        const decimalPercentage = (data[rate] / 100).toPrecision(4);
        if (rate === 'otherEntityRate') {
          if (this.currentProjection.srcEntity.isTestedParty) {
            this.currentProjection.dstEntity.jurisdiction.taxRate = decimalPercentage;
          } else if (this.currentProjection.dstEntity.isTestedParty) {
            this.currentProjection.srcEntity.jurisdiction.taxRate = decimalPercentage;
          }
        } else if (rate === 'testedPartyRate') {
          if (this.currentProjection.srcEntity.isTestedParty) {
            this.currentProjection.srcEntity.jurisdiction.taxRate = decimalPercentage;
          } else if (this.currentProjection.dstEntity.isTestedParty) {
            this.currentProjection.dstEntity.jurisdiction.taxRate = decimalPercentage;
          }
        }
      }
      this.taxRatesConfirmed = false;
      this._planningFormService.setFormStatus('taxRateForm', false);
      this.updateFormValuesInProjection();
    });
  }

  ngOnDestroy() {
    this.formSubscription.unsubscribe();
  }

  saveForm() {
    this._planningApiService.saveScenario(this._planningDataService.getCurrentScenarioValue()).subscribe();
  }

  updateShowTax(taxName) {
    this[taxName] = !this[taxName];
  }

  acceptMessage() {
    this.msgViewed = true;
  }

  confirmTaxRate() {
    this.taxRatesConfirmed = true;
    this._planningFormService.setFormStatus('taxRateForm', true);
    this.updateFormValuesInProjection();
  }

  findTestedParty() {
    if (this.currentProjection.srcEntity.isTestedParty) {
      this.testedParty = this.currentProjection.srcEntity;
      this.otherEntity = this.currentProjection.dstEntity;
    } else if (this.currentProjection.dstEntity.isTestedParty) {
      this.testedParty = this.currentProjection.dstEntity;
      this.otherEntity = this.currentProjection.srcEntity;
    }
  }

  checkIfAlreadyValid() {
    const currentForm = this._planningFormService.getCurrentFormStatus();
    if (currentForm.taxRateForm) {
      this.taxRatesConfirmed = true;
    }
  }

  updateFormValuesInProjection() {
    const currentFormStatus = this._planningFormService.getCurrentFormStatus();
    this._planningDataService.updateFormValues(currentFormStatus, this.currentProjection.projectionId);
  }

  private getMetaData() {
    let currentJurIsos = [];

    currentJurIsos.push({ 'jurisdictionIso': this.currentProjection.srcEntity.jurisdiction.isoCode });
    currentJurIsos.push({ 'jurisdictionIso': this.currentProjection.dstEntity.jurisdiction.isoCode });

    this._planningApiService.getJurisdictionMetaData({ 'jurisdictionIsoCodes': currentJurIsos }).subscribe(({ data }) => {
      this.defaultRates = {
        [this.currentProjection.srcEntity.jurisdiction.isoCode]: data[this.currentProjection.srcEntity.jurisdiction.isoCode] || data.default,
        [this.currentProjection.dstEntity.jurisdiction.isoCode]: data[this.currentProjection.dstEntity.jurisdiction.isoCode] || data.default
      };

      if (parseFloat(this.taxRateForm.get('otherEntityRate').value) === 0 && this.otherEntity) {
        if (this.defaultRates[this.otherEntity.jurisdiction.isoCode] && this.defaultRates[this.otherEntity.jurisdiction.isoCode].taxRate) {
          this.taxRateForm.patchValue(
            { 'otherEntityRate': (this.defaultRates[this.otherEntity.jurisdiction.isoCode].taxRate * 100).toPrecision(4) }
          );
        } else {
          this.taxRateForm.patchValue(
            { 'otherEntityRate': 0 }
          );
        }
      }
      if (parseFloat(this.taxRateForm.get('testedPartyRate').value) === 0 && this.testedParty) {
        if (this.defaultRates[this.testedParty.jurisdiction.isoCode] && this.defaultRates[this.testedParty.jurisdiction.isoCode].taxRate) {
          this.taxRateForm.patchValue(
            { 'testedPartyRate': (this.defaultRates[this.testedParty.jurisdiction.isoCode].taxRate * 100).toPrecision(4) }
          );
        } else {
          this.taxRateForm.patchValue(
            { 'testedPartyRate': 0 }
          );
        }
      }
    });
  }

}
